import React, { useState, useEffect } from 'react'
import { Row, Pagination, Col } from 'antd'
import { isEmpty } from 'lodash'

import DataCard from './DataCard'
import Loading from './Loading'
import ImageDataCard from './ImageDataCard'

export default function CardList({
  list,
  renderItem,
  preserveOrder = false,
  setShowOnlyTesteRapido,
  showOnlyTesteRapido,
  rapidTest
}) {
  const [isLoading, setLoading] = useState(false)
  const [hasList, setHasList] = useState(false)
  const [listIsEmpty, setListIsEmpty] = useState(false)

  const [currentPage, setCurrentPage] = useState(1)

  const pageSize =
    currentPage === 1 && rapidTest
      ? 8
      : currentPage === 2 && !showOnlyTesteRapido && rapidTest
      ? 8
      : 9
  function paginate(array, pageNumber) {
    console.log(array, pageNumber, 'TESTE!!')
    return array.slice((pageNumber - 1) * pageSize, pageNumber * pageSize)
  }

  useEffect(() => {
    if (isEmpty(list)) {
      setLoading(true)
    } else if (list === 'Network Error') {
      setLoading(false)
    } else if (list === 'empty') {
      setListIsEmpty(true)
      setLoading(false)
    } else {
      setHasList(true)
      setLoading(false)
    }
  }, [list]) // eslint-disable-line

  const handleRenderTesteRapido = () => {
    console.log(rapidTest)
    if (rapidTest && currentPage === 1) {
      return (
        <Col
          className="gutter-row"
          style={{ flex: 1 }}
          data-cy="exam_testeRapido">
          <ImageDataCard
            style={{ width: '60px', height: '60px' }}
            alt=""
            onClick={() => {
              setShowOnlyTesteRapido(!showOnlyTesteRapido)
            }}>
            <div>
              <h2>{showOnlyTesteRapido ? 'Mostrar todos' : 'Teste Rápido'}</h2>
            </div>
          </ImageDataCard>
        </Col>
      )
    } else {
      return null
    }
  }

  return (
    <div className="_content-handler">
      {isLoading ? (
        <Loading />
      ) : hasList ? (
        <div className="responsive-container" style={{ padding: 24 }}>
          <Row gutter={[24, 24]}>
            {handleRenderTesteRapido()}

            {list !== null && list !== undefined && list !== 'empty'
              ? paginate(list, currentPage)
                  .sort((a, b) => {
                    if (preserveOrder) return 0
                    if (a.name < b.name) {
                      return -1
                    }
                    if (a.name > b.name) {
                      return 1
                    }
                    return 0
                  })
                  .map((item, i) => renderItem(item, i))
              : null}
          </Row>
        </div>
      ) : listIsEmpty ? (
        <div style={{ margin: 10 }} data-cy="error-card">
          <DataCard>
            <h1>Hm...</h1>
            <p>Parece que não há registro. Cadastre algum!</p>
          </DataCard>
        </div>
      ) : (
        <div style={{ margin: 10 }} data-cy="error-card">
          <DataCard>
            <h1>Ops!!</h1>
            <p>
              Parece que você não está conseguindo conectar-se... Talvez sua
              internet esteja um pouco lenta, tente recarregar a página!
            </p>
          </DataCard>
        </div>
      )}

      <div style={{ width: '100%', textAlign: 'center' }}>
        {list?.length > pageSize && (
          <Pagination
            showSizeChanger={false}
            pageSize={pageSize}
            current={currentPage}
            onChange={e => {
              setCurrentPage(e)
            }}
            total={list?.length}
          />
        )}
      </div>
    </div>
  )
}
